<template>
  <div class="container1">
    <div class="title1" v-if="firstLoading">
      <div class="left">{{ $t("FoodC_C_Available_DlSP") }}</div>
      <div class="right" @click="goUrl">{{ $t("FoodC_C_Purchase_Records_CIUH") }}</div>
    </div>
    <template v-if="benefits.length">
      <AvailableList
        v-for="(item, index) of benefits"
        :key="index"
        :list="item"
        :index="index+1"
        :class="{'available-list':!isShowAll}"
      />
      <div class="show-all-list" v-if="isShowAll" @click="showAllData">
        <span>{{ $t("FoodC_C_More_TIyU") }}</span>
       <svg xmlns="http://www.w3.org/2000/svg" overflow="hidden" viewBox="0 0 48 48" style="width:1em;height:1em;vertical-align:middle"><path fill-rule="nonzero" d="M4.44 16.561l15.878 16.12a4.5 4.5 0 0 0 6.364 0l15.879-16.12a1.5 1.5 0 0 0-2.122-2.122L24.561 30.56a1.5 1.5 0 0 1-2.122 0L6.561 14.44a1.5 1.5 0 1 0-2.122 2.121z"/></svg>
      </div>
    </template>
    <div v-else-if="loading"></div>
    <template v-else>
      <div class="no-has-data">
        <div>{{$t('FoodC_C_No_coupon_DlRu')}}</div>
        <img src="../../../../assets/images/couponCenter/no_gift.png" alt="" />
      </div>
    </template>
  </div>
</template>

<script>
import { getAvailableBenefits } from '@/api/couponCenter/index.js'
import AvailableList from './available-list.vue'
import { isEmpty } from 'lodash-es'
import {
  couponPackageAvailableRealexposureSw,
  couponPackageAvailableMoreSw,
  couponPackageAvailableMoreCk,
  couponPackageHistoryCk
} from '../../trackEvent'
const HISTORY_URL = '/${locale}/couponHistory' // eslint-disable-line
export default {
  components: {
    AvailableList
  },
  data () {
    return {
      allBenefits: [],
      benefits: [],
      loading: false,
      // 设已经购买且有可用券的券包数量为n。当n=0，展示兜底的空态样式；若0<n<=2，按顺序展示即可；若n>=3，默认展示top2的券包，从第三个开始被折叠，点击more可以展开所有。
      isShowAll: false,
      firstLoading: false
    }
  },
  async mounted () {
    await this.initData()
    this.$emit('get-request-complete', {
      type: 'available',
      available_num: this.allBenefits.length,
      status: true
    })
    this.firstLoading = true
  },
  methods: {
    async initData (isTabSwitch) {
      if(!isTabSwitch) this.loading = true
      let res = {}
      try {
         res = await getAvailableBenefits()
      } catch {
        this.loading = false
        this.$emit('get-request-status', {
          status: 'err',
          type:'available'
        })
      }
      this.loading = false
      const data = res.data
      if (!isEmpty(data)) {
        this.handleCouponPackageAvailableRealexposureSw(data.benefits)
        this.allBenefits = data.benefits
        if(isTabSwitch) {
          if(this.isShowAll) {
            this.benefits = this.allBenefits.slice(0, 2)
            return 
          }
          this.benefits = this.allBenefits
          return 
        }
        if (this.allBenefits.length >= 3) {
          this.benefits = this.allBenefits.slice(0, 2)
          this.isShowAll = true
          couponPackageAvailableMoreSw()
        } else {
          this.benefits = this.allBenefits
        }
      }
    },
    showAllData () {
      couponPackageAvailableMoreCk()
      this.benefits = this.allBenefits
      this.isShowAll = false
    },
    handleCouponPackageAvailableRealexposureSw (res) {
      [...res].map((item, index) => {
        couponPackageAvailableRealexposureSw({
          activity_id: item.activityID,
          benefit_id: item.benefitID,
          available_num: item.couponBatchList[0].availableAmount,
          index: index + 1
        })
      })
    },
    goUrl() {
        couponPackageHistoryCk()
        const origin = window.location.origin
        const url = origin + HISTORY_URL
        window.SodaBridge('openPage', {
          target: 'blank',
          url
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.available-list:last-child{
  margin-bottom: 48px;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.container1 {
  padding-top: 48px;
}
.title1 {
  width: 100%;
  margin-bottom:32px;
  display: flex;
  justify-content: space-between;
  
  .left {
      font-family: "Aspira Medium";
      font-size: 36px;
      color: #000000;
      font-weight: 700;
      line-height: 38px;
  }
  .right {
    font-family: 'Aspira Regular';
    font-size: 28px;
    color: #000000;
    font-weight: 400;
  }
}
.show-all-list {
  margin-top: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Aspira Medium";
  font-size: 24px;
  color: #919193;
  text-align: right;
  font-weight: 500;
  margin-bottom: 48px;
  svg {
    opacity: .4;
  }
  span {
    margin-right: 4px;
  }
}
.no-has-data {
  min-height: 100px;
  background: #e3e3e6;
  border-radius: 40px;
  font-family: "Aspira Medium";
  margin-bottom: 60px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  div {
    width: 550px;
    font-size: 24px;
    color: #999999;
    font-weight: 700;
    margin: 20px 0 20px 32px;
  }
  img {
    width: 100px;
    height: 100px;
    position: absolute;
    right: 0;
    left: auto;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
